import React from "react";

const ProductFocusFill = props => (
  <svg viewBox="0 0 20 21" fill="none" {...props}>
    <path
      d="M10 4.563A5.91 5.91 0 004.062 10.5 5.91 5.91 0 0010 16.438a5.935 5.935 0 005.938-5.938A5.935 5.935 0 0010 4.562zm0 10A4.035 4.035 0 015.937 10.5 4.06 4.06 0 0110 6.437c2.227 0 4.063 1.836 4.063 4.063A4.06 4.06 0 0110 14.563zm0-13.75C4.648.813.312 5.188.312 10.5A9.686 9.686 0 0010 20.188c5.313 0 9.688-4.336 9.688-9.688 0-5.313-4.375-9.688-9.688-9.688zm0 17.5A7.786 7.786 0 012.187 10.5c0-4.297 3.477-7.813 7.813-7.813 4.297 0 7.813 3.516 7.813 7.813 0 4.336-3.516 7.813-7.813 7.813zm0-10c-1.21 0-2.188 1.015-2.188 2.187 0 1.21.977 2.188 2.188 2.188 1.172 0 2.188-.977 2.188-2.188 0-1.172-1.016-2.188-2.188-2.188z"
      fill="currentColor"
    />
  </svg>
);

export default ProductFocusFill;
